import React, { useCallback, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useLocalStorage from 'react-localstorage-hook';
import { WidgetIncomingEvent } from '@getvim/vim-connect-app';
import { isEmpty } from 'lodash-es';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';
import { handlePublish } from './utils';
import { ModifyApplication } from '../../mocks/vim-connect-ui-events';

export const ModifyApplicationTab = () => {
  const [payload, setPayload] = useState<any>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage('lastModifyApplicationPayload', '');

  const handlePredefinedPayloadChange = useCallback(
    ({ target: { value } }: SelectChangeEvent) => {
      setPredefinedPayload(value);
      setLastUsedPayload(value);
      setPayload(ModifyApplication.predefinedPayloads[value]);
    },
    [setLastUsedPayload],
  );

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
  }, [handlePredefinedPayloadChange, lastUsedPayload]);

  return (
    <Accordion id="modifyApplicationTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>ModifyApplication</Typography>
        <Select
          id="select-modify-application"
          displayEmpty
          value={predefinedPayload}
          size="small"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(ModifyApplication.predefinedPayloads).map((value, index) => (
            <MenuItem id={`select-modify-application-${index}`} value={value} key={value}>
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-modify-application"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish(payload, WidgetIncomingEvent.ModifyApplication);
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails>
        <MonacoEditor onChange={setPayload} height="20rem" value={payload} />

        <FlexBox>
          <TextField
            id="modifyApplicationPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
